import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { EmailNotificationPreferences } from '@features/email-notifications'
import { useFeatureFlag } from '@shared/feature-flags/useFeatureFlag'
import { useSession } from '@shared/lib/auth/session-store'
import { page } from './ConfigPage.css'
import * as styles from './EmailNotificationsPage.css'

export function EmailNotificationsPage() {
  const enabled = useFeatureFlag('emailNotificationPreferences')
  const userId = useSession((state) => state.user?.id)

  return (
    <div className={page} data-testid="email-notifications-page">
      <header className={styles.header} data-testid="email-notifications-header">
        <Link to="/config" className={styles.backLink} data-testid="email-notifications-back-btn">
          <ArrowLeft size={16} aria-hidden="true" />
          Voltar para configurações
        </Link>
        <div className={styles.titleGroup}>
          <h1 className={styles.title}>Notificações</h1>
          <p className={styles.subtitle}>
            Escolha os emails que você recebe como produtor, afiliado ou coprodutor. Estas
            preferências valem apenas para o seu usuário.
          </p>
        </div>
      </header>
      {enabled && <EmailNotificationPreferences key={userId} />}
    </div>
  )
}
